
import React from 'react';
import ReactDOM from 'react-dom';
import Fade from'../utils/Fade';
class LicenseUpLoad 
{

	static doFileUpload(task)
	{
		let fileUploadArg = task.arg;
	
		$("#indexcommonFileInput").off("change").on("change",function(event){
			LicenseUpLoad.fieldUploadFileSelected(event,fileUploadArg);
		});

		if(fileUploadArg.type)$("#indexcommonFileInput").attr("accept",fileUploadArg.type);
		else $("#indexcommonFileInput").attr("accept","*");

		$("#indexcommonFileInput").click();
	}
	
	
	static tmpXMLHttpRequest = null;
	static fieldUploadFileSelected(e,fileUploadArg)
	{
		var uploadFiles = e.target.files || e.dataTransfer.files;
		var uploadFile = uploadFiles[0];
		
		if(fileUploadArg.maxSize && uploadFile.size > fileUploadArg.maxSize)
		{
			Warning.show({text:fileUploadArg.sizeLimitInfo});
			return;
		}



        let url = fileUploadArg.url;

        var oMyForm = new FormData();    
        oMyForm.append("licenseFile", uploadFile);
        
        var progressBar=$('<progress></progress>').css({'width':'15em','height':'2.1em'}).html('您的浏览器不支持progress元素');
        
        var progressA=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
        var progressBtn=$('<div></div>').append(progressA);
        var progressDiv=$('<div></div>').css({'position':'absolute','top':'40.5%','left':'40%','display':'flex'}).append(progressBar).append(progressBtn);
        var percentageDiv=$('<span></span>');
        var time=$("<span></span>");
        var percentDiv=$('<div></div>').css({'position':'absolute','top':'41%','left':'40.5%','font-size':'0.8em'}).append(percentageDiv).append(time);
        var progressBorder=$("<div></div>").append(progressDiv).append(percentDiv).attr('id','progressBorder').addClass('modal');
        $('body').append(progressBorder);
        
        if(LicenseUpLoad.tmpXMLHttpRequest == null)
        {
        	LicenseUpLoad.tmpXMLHttpRequest=new XMLHttpRequest();
        }

    	LicenseUpLoad.tmpXMLHttpRequest.upload.onprogress = function(pe) {
	        if(pe.lengthComputable) {
	        	progressBorder.css('display','block');
	         	progressBar.attr('max',pe.total);
	        	progressBar.attr('value',pe.loaded);
	         	percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
	        }
	        var nt = new Date().getTime();//获取当前时间
	        var pertime = (nt-this.ot)/1000; //计算出上次调用该方法时到现在的时间差，单位为s
	        this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
	        var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
	        this.oloaded = pe.loaded;//重新赋值已上传文件大小，用以下次计算
	                    
	        //上传速度计算
	        var speed = perload/pertime;//单位b/s
	        var bspeed = speed;
	        var units = 'b/s';//单位名称
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'k/s';
	        }
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'M/s';
	        }
	        speed = speed.toFixed(1);
                        //剩余时间
        	var resttime = ((pe.total-pe.loaded)/bspeed).toFixed(1);
	        
	        var timeContent=' '+speed+units+'，剩余时间：'+resttime+'s';
	        time.html(timeContent); 
    	}

	    LicenseUpLoad.tmpXMLHttpRequest.upload.onloadstart = function(){//上传开始执行方法
	        this.ot = new Date().getTime();   //设置上传开始时间
	        this.oloaded = 0;//设置上传开始时，以上传的文件大小为0
	    };
	    LicenseUpLoad.tmpXMLHttpRequest.onreadystatechange=function(){
			if (LicenseUpLoad.tmpXMLHttpRequest.readyState==4)
		    {
		  		if(LicenseUpLoad.tmpXMLHttpRequest.status==200)
		    	{	
		    		let options={state:'success',text:'更换成功,授权已自动生效！'};Fade.show(options);	
		    	}
			  	else
			    {
			    	let options={state:'error',text:'更换成功！'};Fade.show(options);
			    }
				$('#indexcommonFileInput').val('');
		  	}	

		};

	    LicenseUpLoad.tmpXMLHttpRequest.open("POST", url,true);//+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
	    LicenseUpLoad.tmpXMLHttpRequest.withCredentials = true;
	               
		LicenseUpLoad.tmpXMLHttpRequest.onloadend = function(pe)
	    {
	    	//alert("end");
	        $('#progressBorder').remove();
	    }
	    LicenseUpLoad.tmpXMLHttpRequest.send(oMyForm);
	}


}


export default LicenseUpLoad;



// WEBPACK FOOTER //
// ./src/utils/LicenseUpLoad.js